import React from "react";
import DOMPurify from "dompurify";
import ScrollAnimation from 'react-animate-on-scroll';
import 'animate.css';

import AwardIcon from "../../img/decor/award-icon.png";


function Awarding({awardingData}) {

    //console.log(awardingData);

    return (
        <>
            {
                awardingData ?
                    <section className="mb-[60px] lg:mb-[120px]">

                        <h2 className="mb-8 text-3xl uppercase font-bold leading-tight px-5 text-center max-w-[930px] m-auto
                            lg:text-[55px]">ЦЕРЕМОНІЯ НАГОРОДЖЕННЯ HR WISDOM SUMMIT 2026</h2>

                        <div className="container max-w-screen-xl mx-auto md:px-5">
                            <div className="mb-9 lg:mb-[70px] relative">
                                <img src={awardingData.awarding_photo} className="block w-full"/>
                                <div className="bg-[#fed949] px-4 py-10 md:absolute md:bottom-0 md:left-0 w-full lg:px-10 lg:py-11">
                                    <h2 className="mb-3 uppercase text-[22px] text-center leading-tight lg:text-[32px] lg:text-left lg:max-w-[1020px]">{awardingData.awarding_title}</h2>
                                    <div className="text-center lg:text-left lg:text-[24px]" dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(awardingData.awarding_text, {sanitize: true})}} />
                                </div>
                            </div>

                            <h2 className="font-bold text-[22px] px-5 uppercase text-center mb-12 md:text-left lg:text-[32px] lg:mb-10">Рейтинг складається з трьох частин:</h2>

                            <div className="grid gap-16 md:grid-cols-3 md:gap-6">
                                <div className="relative bg-[#c8d2db] px-5 pt-14 pb-11 text-center md:text-left md:px-6 md:pt-12 md:pb-7">
                                    <h3 className="text-lg font-bold mb-3 lg:text-2xl">РЕЙТИНГ «НАЙКРАЩІ РОБОТОДАВЦІ 2026 року»</h3>
                                    <p className="text-base">
                                        Загальний рейтинг роботодавців, куди увійшли ТОП-100 найкращих компаній,
                                        обрані експертним журі з урахуванням результатів онлайн-голосування на порталі Delo.ua
                                    </p>
                                    <div className="absolute left-1/2 -top-[32.5px] -translate-x-1/2 w-[65px] h-[65px] flex items-center justify-center shadow-[4px_3px_8px_0_rgba(0,0,0,0.15)] rounded-full
                                            md:left-auto md:-top-5 md:right-4 md:translate-x-0">
                                        <img src={AwardIcon} className="absolute w-full h-full"/>
                                        <span className="relative z-10 text-[35px] uppercase text-white lg:text-[44px]">1</span>
                                    </div>
                                </div>

                                <div className="relative bg-[#c8d2db] px-5 pt-14 pb-11 text-center md:text-left md:px-6 md:pt-12 md:pb-7">
                                    <h3 className="text-lg font-bold mb-3 lg:text-2xl">НОМІНАЦІЇ</h3>
                                    <p className="text-base">
                                        Спеціальні номінації отримали роботодавці, які, за оцінками редколегії журналу «ТОП-100. Рейтинги найбільших»,
                                        стали найкращими в окремих напрямках HR: рекрутингу, корпоративній освіті, соціальній підтримці,
                                        роботі з ветеранами та мобілізованими тощо.
                                    </p>
                                    <div className="absolute left-1/2 -top-[32.5px] -translate-x-1/2 w-[65px] h-[65px] flex items-center justify-center shadow-[4px_3px_8px_0_rgba(0,0,0,0.15)] rounded-full
                                            md:left-auto md:-top-5 md:right-4 md:translate-x-0">
                                        <img src={AwardIcon} className="absolute w-full h-full"/>
                                        <span className="relative z-10 text-[35px] uppercase text-white lg:text-[44px]">2</span>
                                    </div>
                                </div>

                                <div className="relative bg-[#c8d2db] px-5 pt-14 pb-11 text-center md:text-left md:px-6 md:pt-12 md:pb-7">
                                    <h3 className="text-lg font-bold mb-3 lg:text-2xl">РЕЙТИНГ «НАЙКРАЩІ HRD»</h3>
                                    <p className="text-base">
                                        Рейтинг найбільш авторитетних спеціалістів у сфері HR. Нагородження керівників HR-підрозділів провідних компаній,
                                        які стали творцями нових стандартів HR у своїх галузях. Переможців визначило експертне журі з урахуванням результатів
                                        онлайн-голосування на порталі <a href="https://delo.ua"><strong>Delo.ua</strong></a>
                                    </p>
                                    <div className="absolute left-1/2 -top-[32.5px] -translate-x-1/2 w-[65px] h-[65px] flex items-center justify-center shadow-[4px_3px_8px_0_rgba(0,0,0,0.15)] rounded-full
                                            md:left-auto md:-top-5 md:right-4 md:translate-x-0">
                                        <img src={AwardIcon} className="absolute w-full h-full"/>
                                        <span className="relative z-10 text-[35px] uppercase text-white lg:text-[44px]">3</span>
                                    </div>
                                </div>
                            </div>

                        </div>
                        
                    </section> : ''
            }
        </>
    )
}

export default Awarding